import React from 'react'

import { usePrices } from 'src/hooks/usePrices'
import { PriceType } from 'src/types/prices'
import type { OfferPriceProps } from './types'

import OfferPriceNet from './OfferPriceNet'
import OfferPriceNetTotal from './OfferPriceNetTotal'
import OfferPriceGross from './OfferPriceGross'
import OfferPriceAllIn from './OfferPriceAllIn'
import OfferPriceAllInDaily from './OfferPriceAllInDaily'
import OfferPriceNetWithFees from './OfferPriceNetWithFees'
import OfferPriceNetWithFeesDaily from './OfferPriceNetWithFeesDaily'

const pricesOptions = {
  [PriceType.Net]: OfferPriceNet,
  [PriceType.Gross]: OfferPriceGross,
  [PriceType.AllIn]: OfferPriceAllIn,
  [PriceType.AllInDaily]: OfferPriceAllInDaily,
  [PriceType.TrivagoNet]: OfferPriceNetTotal,
  [PriceType.NetWithFees]: OfferPriceNetWithFees,
  [PriceType.NetWithFeesDaily]: OfferPriceNetWithFeesDaily,
}

const OfferPrice = ({
  className,
  board,
  nights,
  priceData,
  prime,
  showFrom = false,
  showDiscount = true,
  showDiscountBadge = true,
  showSubtitle = true,
  loading = false,
}: OfferPriceProps) => {
  const { priceType } = usePrices({ rooms: [] })

  const PriceComponent = pricesOptions[priceType]

  return (
    <PriceComponent
      className={className}
      board={board}
      nights={nights}
      priceData={priceData}
      prime={prime}
      showDiscount={showDiscount}
      showDiscountBadge={showDiscountBadge}
      showFrom={showFrom}
      showSubtitle={showSubtitle}
      loading={loading}
    />
  )
}

export default OfferPrice
